import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import UserSection from './UserSection';
import ApiClient from '../../utilities/apiClient';
import AppConfig from '../../AppConfig';
import { color } from 'd3';
import { useAppData } from '../../redux/appDataProvider';
import { setEmailAndNum } from "../../redux/authSlice"
const UserSectionController = ({ setSectionToShow }) => {
  const apiToken = useSelector(state => state.auth.apiToken);
  const userId = useSelector(state => state.auth.userId);
  // const [userInfo, setUserInfo] = useState();
  const { userInfo, setUserInfo } = useAppData();
  const [userNetAssets, setUserNetAssets] = useState();
  const [userProfitBooked, setUserProfitBooked] = useState();
  const [userProfitNotional, setUserProfitNotional] = useState();
  const {selectedYear, setSelectedYear} = useAppData({});
  const { userBanks  = [], setUserBanks } = useAppData(null);
  const [showmodal, setShowModal] = React.useState(false);
  const [showlodder, setShowLodder] = React.useState(false);
  const { margindata, setMarginData } = useAppData();
  const dispatch=useDispatch()
  const fetchUserInfo = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Client.info,
        "POST",
        {
          "ClientCode": userId,
        })
        .then((response) => {
          console.info(response);
          if(response===401){setShowModal(true)}
          if(response && response.Success === "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.info(`data ${responseData}`);
            if (Array.isArray(responseData) && responseData.length > 0) {
              console.info(`setUserInfo ${responseData[0]}`);
              console.log("Ravi==",responseData[0].CLIENT_ID)
              setUserInfo(responseData[0]);
              localStorage.setItem('userid', responseData[0].CLIENT_ID);
              const details = {
                email: responseData[0]?.CLIENT_ID_MAIL,
                mobile: responseData[0]?.MOBILE_NO
              }
              console.log("details", details, responseData[0])
              dispatch(setEmailAndNum(details))
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };

  

  // const fetchAssets = async () => {
  //   try {
  //     // Replace this with your actual data fetching logic
  //     // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
  //     const apiClient = new ApiClient(apiToken);
  //     setShowLodder(true)
  //     apiClient.fetchData(
  //       AppConfig.api.Client.assets,
  //       "POST",
  //       {
  //         "Client_Code": userId,
  //         "FinStyr": selectedYear && selectedYear.Database_Year ? selectedYear.Database_Year : new Date().getFullYear() 
  //       })
  //       .then((response) => {
  //         console.info(response);
  //         setShowLodder(false)
  //         if(response===401){setShowModal(true)}
  //         if(response && response.Success === "True" && response.hasOwnProperty("Success Description")){
  //           let responseData = response["Success Description"]; 
  //           console.info(`data ${responseData}`);
  //           console.info(`NetAssetsDetails ${JSON.stringify(responseData[0])}`);
  //           const netAssets = responseData["NetAssetsDetails"];
  //           let profitBookedData = {
  //             profitBooked: responseData.BookProfit,
  //             items: responseData["BookProfitDetails"]
  //           };
  //           let notionalData = {
  //             notional: responseData.Notional,
  //             items: responseData["NotionalDetails"]
  //           };
  //           let circleData = {
  //             title: "Net Assets",
  //             data:[]
  //           };
  //           Object.entries(netAssets).forEach(([key, value], index) => {
  //             let color;
  //             switch(key){
  //               case 'NetAssets':
  //                 color = "#517AAF";
  //                 break;
  //               case 'MarketValue':
  //                 color = "#FF7F09";
  //                 break;
  //               case 'Total_Return':
  //                 color = "#7DAB1C";
  //                 break;
  //             };
  //             circleData.data.push({
  //               name: key,
  //               value: value,
  //               color: color 
  //             });
  //           }); 
  //           setUserNetAssets(circleData);
  //           setUserProfitNotional(notionalData);
  //           setUserProfitBooked(profitBookedData);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   } catch (error) {
  //     console.error('Error fetching holding data:', error);
  //   }
  // };

  const fetchUserBanks = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      const apiClient = new ApiClient(apiToken);
      setShowLodder(true)
      apiClient.fetchData(
        AppConfig.api.Client.banks,
        "POST",
        {
          "Client_id": userId,
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if(response===401){setShowModal(true)}
          if(response && response.Success === "True" && response.hasOwnProperty("Success Description")){
            let responseData = response["Success Description"]; 
            console.info(`data ${JSON.stringify(responseData)}`);
            if (Array.isArray(responseData) && responseData.length > 0) {
              console.info(`setUserBanks ${responseData}`);
              setUserBanks(responseData);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };
  const margin = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      const apiClient = new ApiClient(apiToken);
      setShowLodder(true)
      apiClient.fetchData(
        AppConfig.api.margin.balance,
        "POST",
        {
          "client_id": userId,
        })
        .then((response) => {
          
          setShowLodder(false)
          if(response===401){setShowModal(true)}
          if(response && response.Success === "True"){
            let responseData = response; 
            console.log('responseData*****',response.balancedata.result?.BalanceList[0].limitObject)
           // if ( responseData.length > 0) {
            
              setMarginData(responseData.balancedata.result?.BalanceList[0].limitObject);
            //}
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };
  
  useEffect(() => {
    // Simulate fetching data from an API or some other source
    // Commented by dev-trupti to check the XTS token login - 4
    fetchUserInfo();
    // fetchAssets();
    fetchUserBanks();
    margin();

  }, [selectedYear]); // Empty dependency array to fetch data only once on component mount

  return <UserSection 
    userInfo={userInfo} 
    // userNetAssets={userNetAssets} 
    // userProfitBooked={userProfitBooked} 
    // userProfitNotional={userProfitNotional} 
    setSectionToShow={setSectionToShow}
    showmodal={showmodal}
    showlodder={showlodder}
    margindata={margindata}
    />;
};

export default UserSectionController;
